import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { Profile } from "../types/Profile";

const fetchProfile =
  (authHeader: string, profileId: number) => async (): Promise<Profile> => {
    const res = await axios.get<Profile>(
      `${env.verifyServiceUrl}individual/profile/${profileId}/`,
      { headers: { Authorization: authHeader } }
    );
    return res.data;
  };

export const useRetrieveProfile = (
  id?: number,
  options?: { enabled?: boolean }
) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  const enabled = (options?.enabled ?? true) && !!id;

  return useQuery({
    queryKey: ["profile", id],
    queryFn: fetchProfile(authHeader, id as number),
    enabled,
    retry: false,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    onError: (err: any) => {
      const status = err?.response?.status ?? err?.request?.status;
      if (status === 500 || status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
    },
  });
};
